import { render, staticRenderFns } from "./PremiumClaimsSummary.vue?vue&type=template&id=1ba41ac3&"
import script from "./PremiumClaimsSummary.vue?vue&type=script&lang=js&"
export * from "./PremiumClaimsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports